<template lang="html">
    <section class="dashboard">
        <div class="row">
            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 grid-margin stretch-card">
                <total-revenue-card/>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 grid-margin stretch-card">
                <total-orders-card/>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 grid-margin stretch-card">
                <total-revenue-card/>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 grid-margin stretch-card">
                <total-revenue-card/>
            </div>
        </div>
        <div class="row">
            <totals-compare-chart/>
        </div> 
        <div class="row">
            <div class="col-12 grid-margin">
                <div class="card">
                    <div class="card-body">
                        <h5 class="card-title mb-4"> Restaurants </h5>
                        <div class="table-responsive">
                            <table class="table center-aligned-table">
                                <thead>
                                    <tr>
                                        <th class="border-bottom-0">No. </th>
                                        <th class="border-bottom-0">Restaurant </th>
                                        <th class="border-bottom-0">Org. No </th>
                                        <th class="border-bottom-0">Type </th>
                                        <th class="border-bottom-0">Phone </th>
                                        <th class="border-bottom-0">Address </th>
                                        <th class="border-bottom-0">City </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(r, index) in restaurants">
                                        <td> {{ index + 1 }} </td>
                                        <td> {{ r.restaurantName }} </td>
                                        <td> {{ r.organizationNumber }} </td>
                                        <td> {{ r.restaurantType }} </td>
                                        <td> {{ r.phoneNumber }} </td>
                                        <td> {{ r.address }} </td>
                                        <td> {{ r.city }} </td>
                                    </tr>
                                </tbody>
                            </table>     
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script lang="js">
import { mapState } from 'vuex'
import OrderMessages from '../../services/ordermessages'
import TotalRevenueCard from '../Dashboards/TotalRevenueCard'
import TotalOrdersCard from '../Dashboards/TotalOrdersCard'
import TotalsCompareChart from '../Dashboards/TotalsCompareChart'
export default {
  name: 'dashboard',
    components: {
        TotalRevenueCard,
        TotalsCompareChart,
        TotalOrdersCard
    },
    computed: {
        ...mapState({
            restaurants: state => state.restaurants.restaurants
        })
    },
    methods: {
      
    },
    async created () {
        
        await OrderMessages.createHubConnection(this.$store.state.login.token);
        await OrderMessages.connectToServer();
        this.$store.state.restaurants.restaurants.forEach(async (restaurant) => {
            await OrderMessages.registerToGroup(restaurant.restaurantId);
        });
        await OrderMessages.registerToServerEvent('transferOrderMessage');
    },
    destroyed() {
        this.$store.state.restaurants.restaurants.forEach(async (restaurant) => {
            await OrderMessages.unregisterFromGroup(restaurant.restaurantId);
        });
    }
}
</script>

<style scoped lang="scss">